// Keep a target timeline instead of rounding every frame to the next refresh.
// Rounding relative to the last draw turns 75 Hz into 37.5 FPS, for example.
export function createFramePacer(fps=60){
 const interval=1000/fps,tolerance=.7;
 let next=null;
 return {
  reset(){next=null;},
  shouldRender(time){
   if(!Number.isFinite(time))return false;
   if(next===null||time-next>interval*2){next=time+interval;return true;}
   if(time+tolerance<next)return false;
   next+=interval;return true;
  }
 };
}

// Only sample a continuous active period. Idle rendering is deliberately off.
export function createFrameSample(windowMs=900){
 let start=null,frames=0,cpu=0;
 function reset(){start=null;frames=0;cpu=0;}
 return {reset,add(time,cpuMs){
  if(start===null)start=time;
  frames++;cpu+=cpuMs;
  const duration=time-start;
  if(duration<windowMs||frames<2)return null;
  const result={fps:(frames-1)*1000/duration,frameMs:duration/(frames-1),cpuMs:cpu/frames};
  reset();return result;
 }};
}
